"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Base Module class to assign and pass option variables to other internal modules of ImageResize
 *
 * @export
 * @abstract
 * @class BaseModule
 * @implements {IBaseModule}
 */
var BaseModule = /** @class */ (function () {
    function BaseModule(imageResize) {
        this.overlay = imageResize.overlay;
        this.img = imageResize.image;
        this.options = imageResize.options;
        this.imageResize = imageResize;
    }
    return BaseModule;
}());
exports.BaseModule = BaseModule;
//# sourceMappingURL=BaseModule.js.map